module.exports = __webpack_public_path__ + "static/media/icons.98bc821d.svg";